//messages.js
export default {
    hold_tag_id: "Hold Tag Id",
    nonconformance_id: "Nonconformance Id",
    reason: "Reason",
    verified_by: "Verified By",
    verified_date: "Verified Date",
    nine_point_submission: "9 Point Submission",
    nine_point_submission_by: "9 Point Submission By",
    nine_point_submission_date: "9 Point Submission Date",
    strip_chart: "Strip Chart",
    strip_chart_by: "Strip Chart By",
    strip_chart_date: "Strip Chart Date",
    recipe_sheet: "Recipe Sheet",
    recipe_sheet_by: "Recipe Sheet By",
    recipe_sheet_date: "Recipe Sheet Date",
    process_sheet: "Process Sheet",
    process_sheet_by: "Process Sheet By",
    process_sheet_date: "Process Sheet Date",
    customer_contacted_by: "Customer Contacted By",
    customer_contacted_date: "Customer Contacted Date",
    edit_nonconformance_hold_tag: "Edit Nonconformance Hold Tag",
    add_nonconformance_hold_tag: "Add Nonconformance Hold Tag",
    delete_nonconformance_hold_tag: "Delete Nonconformance Hold Tag",
    nonconformance_hold_tags: "Nonconformance Hold Tags",
    delete_nonconformance_hold_tag_confirm: "This action is not reversible!",
    printHoldTag: "Print Hold Tag",
    addHoldTag: "Add Hold Tag",
    viewHoldTag: "View Hold Tag",
    hold_tag: "Hold Tag",
    no_hold_tag: "No Hold Tag",
};
